import * as React from 'react';

import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { CallHistoryMethodAction, goBack } from 'connected-react-router';

import AppState from '@webapp/store/state';

import { Translate } from 'react-localize-redux';

import styled from 'styled-components';

import BackIcon from '@components/basics/icons/back';
import Typography from '@components/basics/typography';

import SubscriptionBoxCtrl from '@webapp/controllers/subscription/subscription-box';
import SubscriptionsInvoicesCtrl from '@webapp/controllers/subscription/subscription-invoices';
import { ListSubscriptionsResponse } from '@common/types/subscription-manager/list-subscriptions-response';
import { useParams } from 'react-router';
import { pluralize } from '../../../../../utils/pluralize';
import { ListSubscriptions } from '../../../../../store/subscription-manager/action-creators';

interface SubscriptionsInvoicesPageProps {
  className?: string;
  summary?: ListSubscriptionsResponse;
  handleBack: () => CallHistoryMethodAction;
  listSubscriptions: () => ListSubscriptions;
}

const mapStateToProps = (state: AppState) => ({
  summary: state.subscriptionManager.summary,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  handleBack: () => dispatch(goBack()),
  listSubscriptions: () => dispatch(new ListSubscriptions()),
});

const SubscriptionsInvoicesPage: React.FC<SubscriptionsInvoicesPageProps> = ({
  className,
  summary,
  handleBack,
  listSubscriptions,
}) => {
  React.useEffect(() => {
    listSubscriptions();
  }, [listSubscriptions]);

  const { category, id } = useParams<{
    category: keyof ListSubscriptionsResponse;
    id: string;
  }>();

  if (!summary || !category || !id) {
    return null;
  }

  const subscription = summary[category].find((s) => s.id === id);

  if (!subscription) {
    return null;
  }

  const totalInvoices = subscription.subscriptions.reduce(
    (memo, s) => memo + s.invoiceCount,
    0
  );

  return (
    <div className={`${className || ''}`}>
      <BackIcon className="mb-40" onClick={handleBack} />
      <Typography className="mb-40" type="analytics-nav">
        <Translate id="USER_PROFILE.SUBSCRIPTION.INVOICES.TITLE" />
      </Typography>
      <SubscriptionBoxCtrl
        title={subscription.name}
        avatar={subscription.avatar}
        boxText={`${totalInvoices} ${pluralize('invoice', totalInvoices)}`}
        opened
      >
        <SubscriptionsInvoicesCtrl
          category={category}
          subscription={subscription}
          noTitle
        />
      </SubscriptionBoxCtrl>
    </div>
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(styled(SubscriptionsInvoicesPage)``);
